import React, { useEffect, useState } from "react";
import other_img from "../../../assets/images/other_img.png";
import other2 from "../../../assets/images/other2.png";
import other3 from "../../../assets/images/other3.png";
import other4 from "../../../assets/images/other4.png";
import Recommended from "./Recommended";
const Other_Data = [
  {
    id: 1,
    img: other_img,
    heading: "Vendor Name",
    para: "Order last time on 01/06/2022 Products: Potato, Tomato, Chilli Bill Amount: 400$",
  },
  {
    id: 2,
    img: other2,
    heading: "Vendor Name",
    para: "Order last time on 01/06/2022 Products: Potato, Tomato, Chilli Bill Amount: 400$",
  },
  {
    id: 3,
    img: other3,
    heading: "Vendor Name",
    para: "Order last time on 01/06/2022 Products: Potato, Tomato, Chilli Bill Amount: 400$",
  },
  {
    id: 4,
    img: other4,
    heading: "Vendor Name",
    para: "Order last time on 01/06/2022 Products: Potato, Tomato, Chilli Bill Amount: 400$",
  },
];

function Result(props) {
  const {
    responseData,
    ven_name,
    setVen_name,
    setSelectedFileName,
    dbdatapdf,
  } = props;
  const { responseDatapdf, selectedFileName, setResponsedatapdf } = props;
  const { setShow, loader , setLoader, setOpenModal , setLoaderModal } = props;


  const [activeTab, setActiveTab] = useState("Recommended");
  const [isActive, setIsActive] = useState(false);
  const [isBuy, setIsBuy] = useState(false);


  return (
    <div className="custom_height">
      <div className=" custom_height-inner flex flex-col md:flex-row   ps-5 md:ps-8  pe-5 md:pe-14 2xl:px-[154px]  md:gap-8  2xl:gap-32 justify-center ">
        <div className="w-full dashboard-recommended  md:w-[90%] ">
          <div className="tabs   mb-3 flex  justify-between ">
          </div>

          {activeTab == "Recommended" && (
            <div className="flex  Recommended-inner">
              <div className="w-100">
                <Recommended
                  dbdatapdf={dbdatapdf}
                  responseData={responseData}
                  responseDatapdf={responseDatapdf}
                  setShow={setShow}
                  setOpenModal={setOpenModal}
                  newLoader = {loader}
                  setNewLoader = {setLoader}
                  ven_name={ven_name}
                  setVen_name={setVen_name}
                  setSelectedFileName={setSelectedFileName}
                  selectedFileName={selectedFileName}
                  setResponsedatapdf={setResponsedatapdf}
                  setLoaderModal = {setLoaderModal}
                />
              </div>
              {/* <div>
                <Analyzedpdf heading="History of Analysed PDFs" hide="d-none" />
              </div> */}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Result;
